;$(function() {

	var Additional = {
		show: _=>{
			_.attr('data-text', _.text())
				.text('Скрыть')
				.next().slideDown();
		},
		hide: _=>{
			_.text(_.data('text'))
				.removeAttr('data-text')
				.next().slideUp();
		}
	}

	$(document).on('click', '.filter-save__show-more', function(e) {
		e.preventDefault();

		if ($(this).next().css('display') == 'block')
			Additional.hide($(this));
		else
			Additional.show($(this));

	});

});